// UserHashtagCard.js
'use strict';
import { connect } from 'react-redux';

import UserHashtagCard from '../component/UserHashtagCard.jsx';
import getUserData from '../selector/getUserData.js';
import { HASHTAG_FEED_USER } from '../RemoteConfigKeys.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getUsername from '../selector/getUsername.js';
import getGoalData from '../selector/getGoalData.js';

const mapStateToProps = (state, { userId }) => {
  const fundingId = getLiveStreamData(
    state,
    [userId, 'privateShow'],
    'fundingId'
  );
  const performingId = getLiveStreamData(
    state,
    [userId, 'privateShow'],
    'performingId'
  );
  return {
    hashtagFeedUser: getRemoteConfigData(state, HASHTAG_FEED_USER),
    isStreaming: getLiveStreamData(state, [userId], 'isLiveStreaming'),
    displayName: getUsername(state, userId, 'displayName'),
    username: getUserData(state, userId, 'username'),
    hashtags: getUserData(state, userId, 'hashtags'),
    streamTitle: getLiveStreamData(state, [userId], 'title'),
    privateShowTitle:
      getGoalData(state, [performingId, 'levels', 0], 'title') ||
      getGoalData(state, [fundingId, 'levels', 0], 'title'),
    isExclusive: getLiveStreamData(state, [userId], 'isExclusive'),
  };
};

export default connect(mapStateToProps, null)(UserHashtagCard);
